module.exports = __webpack_public_path__ + "static/media/iPhone14-2.8cde83c2.png";